import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751411769743-hue-painting-logo-blue%202.png" 
                alt="Hue Painting Pro" 
                className="h-8 w-auto brightness-0 invert"
              />
              <span className="text-xl font-bold">Hue Painting Pro</span>
            </div>
            <p className="text-gray-300 mb-4">
              Professional apartment painting services in Burbank, California. We specialize in rental property painting, apartment turnover painting, and complete apartment painting solutions.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMapPin} className="h-4 w-4 text-blue-400" />
                <span className="text-gray-300">Serving Burbank, CA and surrounding areas</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="h-4 w-4 text-blue-400" />
                <span className="text-gray-300">(818) 333-6892</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="h-4 w-4 text-blue-400" />
                <span className="text-gray-300">huepaintservice@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Apartment Painting</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Rental Property Painting</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Apartment Turnover</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Interior Painting</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Color Consultation</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Services</Link></li>
              <li><Link to="/blog" className="hover:text-blue-400 transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition-colors">Contact</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition-colors">Free Quote</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Hue Painting Pro. All rights reserved. Professional apartment painting services in Burbank, California.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;